/*

    Those functions are used when you want to update an open tab of a sale/buy with fresh data
    That could happen for example when you hook a fixed asset to a sale and want the action
    on the line to change from "correlate" to "correlated"
 */

import axios from "axios";
import {setEditSales} from "../_reducers/DataPanel/Sales/salesSlice";
import {setEditBuys} from "../_reducers/DataPanel/Buys/buysSlice";

export const selfUpdateSale = (dispatch, SALES, companyId, target_id) => {
    try {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
                docId: target_id,
                section: "Sales",
            }
        }).then((res) => {
            if (res.data.status === "200") dispatch(setEditSales(res.data.data));
        }).catch((err) => {
            console.log(err);
        })
    } catch (err) {
        console.log(err);
    }
}

export const selfUpdateSaleByMark = (dispatch, editSales, companyId, target_mark) => {
    try {
        if (Object.values(editSales).some((el) => el.mark === target_mark)) {
            axios.get(`${process.env.REACT_APP_API_URL2}/sale/get-sale-by-mark`, {
                headers: { "Content-Type": "application/json" },
                params: {
                    company: companyId,
                    mark: target_mark,
                }
            }).then((res) => {
                if (res.data.status === "200") dispatch(setEditSales(res.data.data));
            }).catch((err) => {
                console.log(err);
            })
        }
    } catch (err) {
        console.log(err);
    }
}

export const selfUpdateBuy = (dispatch, BUYS, companyId, target_id) => {
    try {
        if (BUYS.editBuys._id === target_id) {
            axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
                headers: { "Content-Type": "application/json" },
                params: {
                    company: companyId,
                    docId: target_id,
                    section: "Buys",
                }
            }).then((res) => {
                if (res.data.status === "200") dispatch(setEditBuys(res.data.data));
            }).catch((err) => {
                console.log(err);
            })
        }
    } catch (err) {
        console.log(err);
    }
}
